<template>
  <div class="preference">
    <div class="type">{{ initData.preferenceType }}</div>
    <div class="preferenceDetail">
      <div
        :class="['chooseBtn', currentValue === item ? 'chooseBtnActive' : '']"
        v-for="(item, index) in initData.tagList"
        :key="index"
        @click="changeValue(item)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: {
      type: Object,
    },
    currentItem: {
      type: Number, // 当前传入偏好类型对应index
    },
  },
  data() {
    return {
      currentValue: this.initData && this.initData.tagList[0], // 默认值当前偏好类型的第一项
    };
  },
  mounted() {},
  methods: {
    changeValue(val) {
      this.currentValue = val;
      this.$emit("changeButton", { val, index: this.currentItem });
    },
  },
  computed: {},
};
</script>

<style>
/* 偏好选择样式 */
.preference {
  display: flex;
  align-items: baseline;
  font-size: 14px;
  padding: 5px 0 0 5px;
}
.preferenceDetail {
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
  font-size: 13px;
  width: 380px;
}
.type {
  width: 100px;
  text-align: right;
  margin-top: 20px;
  text-align: center;
}
.chooseBtn {
  padding: 2px 16px;
  border: 1px solid #ff9a28;
  border-radius: 50px;
  color: #222;
  margin-right: 10px;
}
.chooseBtnActive {
  background-color: #ff9a28;
  color: #fff;
}
.chooseBtn:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/coffee/components/PreferenceItem.vue